import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=187e58a0&scoped=true&"
import script from "./TemplatePreview.vue?vue&type=script&lang=js&"
export * from "./TemplatePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e58a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187e58a0')) {
      api.createRecord('187e58a0', component.options)
    } else {
      api.reload('187e58a0', component.options)
    }
    module.hot.accept("./TemplatePreview.vue?vue&type=template&id=187e58a0&scoped=true&", function () {
      api.rerender('187e58a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/TemplatePreview.vue"
export default component.exports